export default __webpack_public_path__ + "static/media/gloves6.9672803f.jpg";